import { ENDPOINTS_TAGS, rootApi } from 'src/v2/store/api/rootApi'

import { IUserMembership } from '../membership.types'

export const userApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    updateUserMembership: builder.mutation<null, Partial<IUserMembership>>({
      query: (data) => {
        const { id, role, status } = data
        return {
          url: `/users-membership/${id}`,
          method: 'PATCH',
          data: { role, status },
        }
      },
      invalidatesTags: [ENDPOINTS_TAGS.GET_USER],
    }),
    deleteUserMembership: builder.mutation<{}, IUserMembership['id']>({
      query: (membershipId) => ({
        url: `/users-membership/remove/${membershipId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [
        ENDPOINTS_TAGS.USERS,
        ENDPOINTS_TAGS.GET_USER,
        ENDPOINTS_TAGS.GET_CLINIC,
      ],
    }),
    generateApiKey: builder.mutation<{}, IUserMembership['id']>({
      query: (membershipId) => ({
        url: `/v3/auth/generate-api-key`,
        data: { membershipId: membershipId },
        method: 'POST',
      }),
      invalidatesTags: [ENDPOINTS_TAGS.USERS, ENDPOINTS_TAGS.GET_USER],
    }),
  }),
})

export const {
  useUpdateUserMembershipMutation,
  useDeleteUserMembershipMutation,
  useGenerateApiKeyMutation,
} = userApi
